import { type SizeFiltersResponse } from '@/modules/filters/aliases';

/**
 * Builds bidirectional maps between size names and composite IDs.
 * Used to convert YMAL simple size strings to/from composite IDs.
 */
export function mapYMALSizesToCompositeIds(sizeTree: SizeFiltersResponse): {
  nameToIds: Map<string, string[]>;
  idToName: Map<string, string>;
} {
  const nameToIds = new Map<string, string[]>();
  const idToName = new Map<string, string>();

  const regions = sizeTree
    .filter((department) => department.name)
    .flatMap((department) => department.children)
    .filter((group) => group.name)
    .flatMap((group) => group.children)
    .filter((region) => region.name);

  for (const region of regions) {
    for (const size of region.children) {
      if (!size.name || !size.composite_id) {
        continue; // Skip invalid leaves
      }

      // Name to IDs (one name can have multiple IDs across categories)
      const existing = nameToIds.get(size.name) || [];
      nameToIds.set(size.name, [...existing, size.composite_id]);

      // ID to name (one-to-one)
      idToName.set(size.composite_id, size.name);
    }
  }

  return { nameToIds, idToName };
}
